<template>
  <div class="fullWidth recommend">
    <span class="text inline-block">防火门</span>
    <div class="core fullWidth infinite-list" style="overflow: auto">
      <div
        class="card infinite-list-item pointer"
        v-for="(item, index) in list"
        :key="index"
        @click="toPage(item)"
      >
        <img :src="item.picUrl" alt="" width="150px" height="150px" />
        <div class="des">
          <div>
            {{ item.name}}
          </div>
        </div>
        <div
          class="footer"
          style="
            display: flex;
            color: #f00;
            font-size: 14px;
            align-items: flex-end;
          "
        >
          <!-- <div class="prefix">¥</div>
          <div class="value" style="font-size: 18px; font-weight: 600">
            {{ item.retailPrice }}
          </div> -->
        </div>
      </div>
    </div>
    <div style="text-align: right">
      <el-link><a target="_blank" style="cursor:pointer; font-weight: bold; color: #1f2d3d; font-size: large; " @click="goPage(parent.id)">更多防火门 > </a></el-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FiredoorGoods',
  props: {
    parent: '',
  },
  watch: {
    parent: {
      handler(newVal, oldVal) {
        this.list = newVal;
        if (this.list != null) {
          this.getList();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      //家用商品
      list: [],
      total: 0,
      listLoading: true,
    };
  },
  methods: {
    //跳转防火门
    goPage(id) {
      this.$router.push('/PC/searchMore/' + id);
    },
    getList() {
      this.listLoading = true
      this.list = this.parent.goodsList
    },
    load() {
      // this.count += 5;
      this.$store.commit('increaseCount');
    },
    toPage(item) {
      this.$router.push('/PC/detail/' + item.id);
    },
  },
  // 监听滚轴时间 动态加载数据
  created() {
    this.getList();
  },
};
</script>

<style scoped>
.recommend {
  text-align: center;
}

.recommend .text {
  padding: 20px 0;
  color: #000;
  font-size: 30px;
  font-weight: 600;
}

.core {
  /* width: 1382px; */
  width: 1200px;
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
}

.core .card {
  width: 230px;
  height: 322px;
  margin: 6px 0;
  padding: 0 2px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.core .card .des {
  color: #666;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/PC/firedoor/FiredoorGoods.vue